
export default {
  featured_trending: "🔥 Trending Products",
  featured_recommended: "🛒 Recommended For You",
  featured_best_deals: "⚡ Best Deals Right Now",
  view_all: "View all",
  loading: "Loading...",

  
  

//   CategoryBar

  cat_all: "All",
  cat_fresh: "Fresh",
  cat_vegetables: "Vegetables",
  cat_rice: "Rice",
  cat_meat: "Meat",
  cat_dairy: "Dairy",
  cat_offers: "Offers",


//   Header

    fetching_location: "Fetching location...",
  search_ingredients_products: "Search for ingredients or products...",
  recent: "Recent",
  my_profile: "My Profile",

//   categoryWise

  shop_by_category: "Shop by Category",
  cat_vegetables: "Vegetables",
  cat_fruits: "Fruits",
  cat_rice: "Rice",
  cat_meat: "Meat",
  cat_dairy_products: "Dairy Products",
  cat_spices: "Spices",
  cat_oils: "Oils",

  // MahalIntentSection

   what_are_you_ordering_today: "What Are You Ordering Today?",
  choose_kitchen_needs: "Choose what your kitchen needs right now",
  cat_vegetables: "Vegetables",
  cat_fruits: "Fruits",
  cat_dairy_products: "Dairy Products",
  cat_meat_poultry: "Meat & Poultry",
  cat_seafood: "Seafood",
  cat_rice_grains: "Rice & Grains",
  cat_lentils_pulses: "Lentils & Pulses",
  cat_spices_masalas: "Spices & Masalas",
  cat_edible_oils: "Edible Oils",
  cat_packaging_materials: "Packaging Materials",
  cat_grains_pulses: "Grains & Pulses",
  cat_spices_herbs: "Spices & Herbs",
  cat_rice: "Rice",
  cat_wheat_flour: "Wheat Flour",
  cat_lentils: "Lentils",
  cat_pulses: "Pulses",
  cat_grains: "Grains",
  cat_edible_oils_frozen_ready: "Edible Oils / Frozen & Ready Items",

  // HotDealsSection

  up_to: "Up to",
  off: "OFF",
  limited_time_procurement_deals: "Limited Time Procurement Deals",
  ends_in: "Ends in",
  add: "ADD",
  login_required: "Login required",
  product_already_cart: "Product already in cart 🛒\n\nQuantity updated",
  added_to_cart: "✅ Added to cart",
  add_to_cart_failed: "Add to cart failed",
  "qar": "QAR",
  "buy": "BUY",
  "hour": "hour",
  "minute": "minute",
  "second": "second",

  // VerifiedSuppliers

   verified_suppliers: "Verified Suppliers",
  trusted_partners_procurement: "Trusted partners powering restaurant procurement",
  verified: "Verified",
  fast_delivery: "Fast Delivery",
  min_order_5000: "Min Order ₹5000",
  view_supplier: "View Supplier",
  "qar": "QAR",
  "min_order": "Min Order",
  "min_order_5000": "Min Order QAR5000",
  "fast_delivery": "Fast Delivery",
  "verified_suppliers": "Verified Suppliers",

  // Deals Of The Day
deals_of_the_day: "Deals of the Day",
limited_time_offers_verified_suppliers: "Limited-time offers from verified suppliers",
loading_deals: "Loading deals...",
please_login: "Please login",
backend_error: "Backend error",
failed_update_cart: "Failed to update cart",
add_to_cart: "Add to Cart",
ends_in: "Ends in",
product_already_cart: "Product already in cart 🛒\n\nQuantity updated",
added_to_cart: "✅ Added to cart",
login_required: "Login required",
"qar": "QAR",
"hour": "hour",
"minute": "minute",
"second": "second",

// MahalSponsoredSection
supplier_spotlight: "Supplier Spotlight",
trusted_suppliers_limited_offers: "Trusted suppliers • Limited-time offers",
ends_in_upper: "ENDS IN",
view_product: "View Product",
verified_supplier: "Verified Supplier",
qar: "QAR",
"hour": "hour",
"minute": "minute",
"second": "second",

// PromoStrip

promo_bulk_rice_offers: "Bulk Rice Offers",
promo_up_to_20_off: "Up to 20% off",
promo_meat_deals: "Meat Deals",
promo_fresh_frozen: "Fresh & Frozen",
promo_daily_essentials: "Daily Essentials",
promo_best_prices: "Best Prices",
promo_view_products: "View Products",

// MahalStealDeals

steal_deals_for_you: "Steal deals for you",
qar: "QAR",
error: "Error",
"special_offer": "Special",
"off": "OFF",

// BestSellProducts

best_selling_offers: "Best Selling Offers",
top_deals_for_you: "Top Deals For You",
hot_deals: "Hot Deals",
save_big_today_offers: "Save Big on Today’s Offers",
shop_now: "Shop Now",
off: "OFF",
qar: "QAR",
please_login: "Please login",
product_already_cart: "Product already in cart 🛒\n\nQuantity updated",
added_to_cart: "Added to cart 🛒",
backend_error: "Backend error",

// NewProducts

trending_now: "Trending Now",
discover_loving_today: "Discover what people are loving today",
loading_products: "Loading products...",
new: "New",
view_product: "View Product",
please_login: "Please login",
product_already_cart: "Product already in cart 🛒\n\nQuantity updated",
added_to_cart: "Added to cart 🛒",
backend_error: "Backend error",
added_to_wishlist: "Added to wishlist ❤️",
already_in_wishlist: "Already in wishlist",
wishlist_backend_error: "Wishlist backend error",

// OffersBanner

fresh_deals: "Fresh Deals",
fresh_essentials_delivered: "Fresh Essentials Delivered to Your Doorstep",
shop_vegetables_fruits: "Shop vegetables, fruits & daily groceries at unbeatable prices.",
digital_ordering: "Digital Ordering",
order_smarter_mahal_app: "Order Smarter with the Mahal Mobile App",
browse_compare_suppliers: "Browse, compare suppliers & manage bulk orders in one place.",
fast_delivery: "Fast Delivery",
fast_reliable_bulk_deliveries: "Fast & Reliable Bulk Deliveries",
warehouse_to_kitchen: "From warehouse to kitchen — on time, every time.",
search_products_suppliers: "Search products, suppliers...",
search: "Search",
explore_now: "Explore Now",
download_app: "Download App",
summer_offer: "Summer Offer",
healthy_organic_food: "Healthy Organic Food",
special_offer: "Special Offer",
fresh_organic_food: "Fresh Organic Food",
shop_now: "Shop Now",

// AddBannerSection

limited_offer: "Limited Offer",
offer_banner_1_title: "Up to 50% off on Special Item",
offer_banner_1_desc: "Shop our selection of organic fresh vegetables in a discounted price. 50% off",
offer_banner_2_title: "Get 10% off on Fruits Item",
offer_banner_2_desc: "Shop our selection of organic fresh vegetables in a discounted price. 10% off",
offer_banner_3_title: "Get 75% Organic Vegetable",
offer_banner_3_desc: "Shop our selection of organic fresh vegetables in a discounted price. 75% off",
explore_now: "Explore Now",

// FreshProducts

our_fresh_products: "Our Fresh Products",
no_products_found: "No products found",
please_login: "Please login",
backend_error: "Backend error",
added_to_wishlist: "Added to wishlist ❤️",
already_in_wishlist: "Already in wishlist",
wishlist_backend_error: "Wishlist backend error",
qar: "QAR",

// SpecialProducts

special_products: "Special Products",
exclusive_deals_kitchen: "Exclusive Deals for Your Kitchen",
weekly_discounts: "Weekly Discounts",
fresh_fruits_vegetables: "Fresh Fruits & Vegetables",
save_more_bulk: "Save more when you buy in bulk.",
invalid_product: "Invalid product ❌",
new: "New",

// categoriesSection

loading_products: "Loading products...",
add: "Add",
qar: "QAR",
please_login: "Please login",
product_already_cart: "Product already in cart 🛒\n\nQuantity updated",
added_to_cart: "Added to cart ✅",
backend_error: "Backend error",
"kg": "kg",
"gram": "g",
"box": "Box",
"piece": "Piece",
"pcs": "pcs",
"unit": "unit",

// DeliveryStrip

  "b2b_bulk_orders": "B2B & Bulk Orders",
  "same_day": "Same-Day",
  "scheduled_delivery": "Scheduled Delivery",
  "delivery_time": "10:00 AM – 08:00 PM",
  "reliable_delivery_for": "Reliable next-day delivery for",
  "business_types": "restaurants, retailers, cafés, and bulk buyers",
  "delivery_description": "Designed for businesses that need speed, consistency, and freshness.",
  "read_more": "Read More",
  "contact_sales": "Contact Sales",

// Footer

  "mahal": "Mahal",
  "footer_description": "is a B2B marketplace connecting restaurants with verified suppliers for bulk and daily kitchen needs.",
  "marketplace": "Marketplace",
  "restaurant_offers": "Restaurant Offers",
  "browse_categories": "Browse Categories",
  "find_suppliers": "Find Suppliers",
  "restaurants": "Restaurants",
  "for_restaurants": "For Restaurants",
  "restaurant_login": "Restaurant Login",
  "restaurant_dashboard": "Restaurant Dashboard",
  "my_orders": "My Orders",
  "inventory": "Inventory",
  "for_suppliers": "For Suppliers",
  "supplier_login": "Supplier Login",
  "supplier_dashboard": "Supplier Dashboard",
  "manage_products": "Manage Products",
  "manage_orders": "Manage Orders",
  "support_company": "Support & Company",
  "about_mahal": "About Mahal",
  "contact_support": "Contact Support",
  "help_center": "Help Center",
  "documentation": "Documentation",
  "all_rights_reserved": "All Rights Reserved",
  "secure_payments": "Secure Payments",
  
// Topbar

"free_delivery_qatar": "Free Delivery Across Qatar",
"verified_suppliers": "100% Verified Suppliers",
"fast_order_processing": "Fast Order Processing",
"download_mahal_app": "Download Mahal Mobile App",

};